import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const ScrollableContainer = styled(Box).attrs({
  px: 16,
  py: '10px',
  mt: 33,
})`
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
  border-radius: 5px;
  overflow: scroll;
  height: 190px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
`;

export const RowText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  display: inline-flex;
  flex: 1 1 auto;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

export const SectionTitle = styled(Text).attrs({
  size: 'small',
  fontWeight: 'bold',
  color: 'primaryText',
  my: 10,
})``;

export const IsFetchingContainer = styled(Box).attrs({
  height: 57,
  horizontal: true,
  flow: 10,
  align: 'center',
  p: 10,
  bg: 'foreground',
  borderRadius: 4,
})``;

export const IsFetchErrorContainer = styled(IsFetchingContainer).attrs({
  justify: 'space-between',
})``;

export const ErrorText = styled(Text).attrs({
  size: 'small',
})`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
`;
